export const formattedDate = (date) => {
    if (date) {
        const dateN = new Date(date)
        return new Intl.DateTimeFormat("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
        }).format(dateN)
    } else {
        return ''
    }
}